import React, { FunctionComponent } from 'react';
import { SanityImage } from '../../../types/common';
import { urlFor } from '../../../utils/imageBuilder';
import RichText from '../../RichText';
import ReadMore from '../../ReadMore';

type CardProps = {
  data: {
    image: SanityImage;
    title: string;
    description?: string | null;
    hideTitle?: boolean | undefined;
  };
}

const Card: FunctionComponent<CardProps> = ({ data }) => {
  return (
    <div
      className='card'
    >
      <picture>
        <source media="(min-width:992px)" srcSet={urlFor(data.image).width(500).quality(90).url()} />
        <source media="(min-width:650px)" srcSet={urlFor(data.image).width(1000).quality(90).url()} />
        <img
          src={urlFor(data.image).width(650).quality(100).url()}
          alt={data.image.alt}
        />
      </picture>
      { !data.hideTitle && <p><strong className='card-title'>{data.title}</strong></p> }
      {data.description && (
        <ReadMore>
          <RichText
            value={data.description}
          />
        </ReadMore>
      )}
    </div>
  );
}

export default Card;
